
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CircleBadge extends Vue {
  @Prop(String) readonly width: string | undefined;
}
